import React, { useState, createContext, useContext } from 'react';
type Language = 'id' | 'en';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (id: string, en: string) => string;
  getSlug: (slug: string) => string;
}
// Slug mapping for bilingual URLs
const slugMap: Record<string, {
  id: string;
  en: string;
}> = {
  'tentang-kami': {
    id: 'tentang-kami',
    en: 'about-us'
  },
  'about-us': {
    id: 'tentang-kami',
    en: 'about-us'
  },
  manajemen: {
    id: 'manajemen',
    en: 'management'
  },
  management: {
    id: 'manajemen',
    en: 'management'
  },
  proyek: {
    id: 'proyek',
    en: 'projects'
  },
  projects: {
    id: 'proyek',
    en: 'projects'
  },
  'produk-layanan': {
    id: 'produk-layanan',
    en: 'products-services'
  },
  'products-services': {
    id: 'produk-layanan',
    en: 'products-services'
  },
  keunggulan: {
    id: 'keunggulan',
    en: 'advantages'
  },
  advantages: {
    id: 'keunggulan',
    en: 'advantages'
  },
  konsultasi: {
    id: 'konsultasi',
    en: 'consultation'
  },
  consultation: {
    id: 'konsultasi',
    en: 'consultation'
  },
  kontak: {
    id: 'kontak',
    en: 'contact'
  },
  contact: {
    id: 'kontak',
    en: 'contact'
  },
  'kebijakan-privasi': {
    id: 'kebijakan-privasi',
    en: 'privacy-policy'
  },
  'privacy-policy': {
    id: 'kebijakan-privasi',
    en: 'privacy-policy'
  },
  'syarat-ketentuan': {
    id: 'syarat-ketentuan',
    en: 'terms-of-service'
  },
  'terms-of-service': {
    id: 'syarat-ketentuan',
    en: 'terms-of-service'
  }
};
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('id');
  const t = (id: string, en: string) => {
    return language === 'id' ? id : en;
  };
  // Get slug in current language
  const getSlug = (slug: string) => {
    const mapping = slugMap[slug];
    if (!mapping) return slug;
    return language === 'id' ? mapping.id : mapping.en;
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t,
    getSlug
  }} data-id="element-301">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
// Helper function to get the canonical slug (ID version) from any slug
export function getCanonicalSlug(slug: string): string {
  const mapping = slugMap[slug];
  return mapping ? mapping.id : slug;
}
// Helper function to get slug in specific language
export function getSlugForLanguage(slug: string, lang: Language): string {
  const mapping = slugMap[slug];
  if (!mapping) return slug;
  return lang === 'id' ? mapping.id : mapping.en;
}